import "pixi-spine";
import "pixi.js";
import { utilAnimation } from "../../utils/animation/utilAnimation";
import { utilGrid } from "../../utils/grid/utilGrid";
import { BF2CreateHitArea, L_SHAPE_OFFSET } from "../BF2BuildingGraphicsUtils";
var Container = PIXI.Container;
var Point = PIXI.Point;
export var ANIM_SCALE = 0.72;
export var BF2FinishedScaffolding = function (data, config) {
    var buildingFinishedScaffoldingId = "building_celebration_{0}x{1}";
    var animIndex = 0;
    var balancing = data.balancing, proto = data.proto;
    var animationId = buildingFinishedScaffoldingId.replace("{0}x{1}", balancing.xExtent + "x" + balancing.yExtent);
    var finishedScaffolding = utilAnimation.getSpineAnimation(animationId);
    var LShapeOffset = utilGrid.mapToScreen(L_SHAPE_OFFSET, L_SHAPE_OFFSET);
    var assetPosition = new Point(config.assets[0].offset[0] - LShapeOffset.x, config.assets[0].offset[1] - LShapeOffset.y);
    var hitAreaPosition = new Point(config.assets[0].offset[0] + LShapeOffset.x, config.assets[0].offset[1] + LShapeOffset.y);
    finishedScaffolding.position.set(assetPosition.x, assetPosition.y);
    finishedScaffolding.scale.set(ANIM_SCALE, ANIM_SCALE);
    var container = new Container();
    container.interactive = true;
    container.interactiveChildren = false;
    container.hitArea = BF2CreateHitArea(config.colliders, hitAreaPosition, container, false);
    if (proto.flipped) {
        container.scale.x = container.scale.x * -1;
    }
    if (utilAnimation.isAnimationEnabled()) {
        finishedScaffolding.state.setAnimation(animIndex, animationId, true);
    }
    container.addChild(finishedScaffolding);
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2FinishedScaffolding.ts
// module id = 2206
// module chunks = 3